export class Receivable {
    /** Unique internal idenity of the receivable record in the database. */
    public id: number = 0;

    /** Date that this receivable was computed and thus applies (the asOf date). */
    public day: Date;

    /** Unique internal identity of the coporation associated with the receivable. */
    public corporateId: number = 0;

    /** Name of the corporation associated with this receivable. */
    public corporation: string;

    /** Unique internal identity of the dealership associated with the receivable. */
    public dealershipId: number = 0;

    /** Name of the dealership associated with this receivable. */
    public dealer: string;

    /** Unique internal identity of the lot associated with the receivable. */
    public lotId: number = 0;

    /** Name of the lot associated with this receivable. */
    public lot: string;

    /** Name of the lienholder associated with this receivable. */
    public lienholder: string;

    /** Unique internal identity of the service ticket associated with the receivable. */
    public serviceId: number = 0;

    /** Unique internal identity of the insurance associated with the receivable. */
    public insuranceId: number = 0;

    /** Annual percentage rate from the installment sale contract. */
    public apr: number = 0;

    /** The collection method of the sale terms (true daily or scheduled installment) */
    public method: string;

    /** The regularly scheduled payment due by the buyer for the given frequency. */
    public payment: number = 0;

    /** The payment frequency, how often a payment is due (monthly, weekly, etc...) */
    public frequency: string;

    /** The original princiapl balance of the loan. */
    public initialBalance: number = 0;

    /** The number of payments (term) of the loan. */
    public periods: number = 0;

    /** The payment number of the current payment due. */
    public paymentNumber: number = 0;

    /** Unique internal identity of the contact (buyer) associated with the receivable. */
    public contactId: number = 0;

    /** Full name of the contact (buyer) associated with this receivable. */
    public contact: string;

    /** Indicates whether or not the insurance associated with this receivable is CPI. */
    public insuranceIsCpi: boolean;

    /** Unique internal identity of the insurance company associated with the receivable. */
    public insuranceProviderId: number = 0;

    /** Name of the insurance provider associated with this receivable.  */
    public insuranceProvider: string;

    /** Date when the insurance associated with this vehicle expires. */
    public insuranceExpires: Date;

    /** Unique internal identity of the sale associated with the receivable. */
    public saleId: number = 0;

    /** Date when sale was considerd sold and the contracts were signed. */
    public sold: Date;

    /** Unique internal identity of the inventory item (retail) associated with the receivable. */
    public inventoryId: number = 0;

    /** Unique internal identity of the retail vehicle associated with the receivable. */
    public vehicleId: number = 0;

    /** Year, make and model of the retail vehicle associated with this receivable. */
    public vehicle: string;

    /** Stock number of the retail vehicle associated with this receivable. */
    public stock: string;

    /** Vehicle identification number of the retail vehicle associated with this receivable. */
    public vin: string;

    /** URL pointing to the primary image (if any) of the retail vehicle associated with this receivable. */
    public url: string;

    /** The type identity of the sale associated with this receivable (bhph, outside, etc...) */
    public typeId: number;

    /** The type of sale associated with this receivable (bhph, outside, etc...) */
    public type: string;

    /** Indicates whether or not the sale type is Buy Here - Pay Here (in-house financed) */
    public bhph: boolean;

    /** Indicates whether or not the sale was financed (bhph or outside). */
    public financed: boolean;

    /** The current status of the sale (sold, funded, paid, repo, etc...) */
    public status: string;

    /** The current status group of the sale (progress, active, closed, etc...) */
    public group: string;

    /** The current stage of the sale (sale or quote) */
    public stage: string;

    /** Indicates whether or not the sale associated with this receivable is currently a quote. */
    public quote: boolean;

    /** The number of GPS devices installed on the retail (sold) vehicle. */
    public gpsCount: number = 0;

    /** Unique internal identity of the sale terms associated with the receivable. */
    public termsId: number = 0;

    /** The current amount due from all categories of possible payments. */
    public amount: number = 0;

    /** The payment category based on the current state of the loan repayment and what is currently due. */
    public category: string;

    /** The current amount due for the mv loan or drive out price. */
    public loan: number = 0;

    /** The current due date of the mv loan or drive out price. */
    public loanDue: Date;

    /** The current amount due for the deposit, if any. */
    public deposit: number = 0;

    /** The current due date of the deposit, if any. */
    public depositDue: Date;

    /** The current amount due for the initial down payment, if any. */
    public initial: number = 0;

    /** The current due date of the initial down payment, if any. */
    public initialDue: Date;

    /** The current amount due for the deferred down payment(s), if any. */
    public deferred: number = 0;

    /** The current due date of the deferred down payment, if any.  */
    public deferredDue: Date;

    /** Total amount of unpaid deferred down payments. */
    public unpaidDeferred: number = 0;

    /** The current amount due for the cpi (insurance), if any.  */
    public cpi: number = 0;

    /** The current due date of the cpi (insurance), if any.  */
    public cpiDue: Date;

    /** The date the cpi (insurance), if any, ends.  */
    public cpiEnds: Date;

    /** Late fee percentange set on the associated sale for this receivable.  */
    public lateFeePercent: number = 0;

    /** The current amount due for the late fees, if any.  */
    public lateFees: number = 0;

    /** Total amount of all waived late fees, if any.  */
    public lateFeesWaived: number = 0;

    /** The current due date of the late fees, if any.  */
    public lateFeesDue: Date;

    /** The current amount due for the bounce fees, if any.  */
    public bounceFees: number = 0;

    /** The current due date of the bounce fees, if any.  */
    public bounceFeesDue: Date;

    /** The current due date based on the current state of the loan re-payment and what is due.  */
    public due: Date;

    /** The past due date, if any, based on the oldest payment that is still not fully paid.  */
    public pastDueDate: Date;

    /** The number of days the acocunt is past due, negative if not past due. */
    public daysPastDue: number = 0;

    /** The selling price from the associated sale */
    public price: number = 0;

    /** The total amount of any unpaid items for the loan. */
    public payoff: number = 0;

    /** The current princiapl balance of the loan. */
    public balance: number = 0;

    /** Indicates the tax method used for the loan (DEFERRED or PAID) */
    public taxMethod: string;

    /** The current tax balance of the loan, if any. */
    public taxBalance: number = 0;

    /** The total amount of any unpaid payments. */
    public paymentBalance: number = 0;

    /** Total amount of any earned unpaid interest. */
    public unpaidEarnedInterest: number = 0;

    /** Computed amount of any potential unearned interest for the rest of the loan life. */
    public unearnedInterest: number = 0;

    /** Computed sum of all trade allowances less trade payoffs. */
    public tradeNet: number = 0;

    /** Computed sum of all deposits, initials and deferred downs paid with cash. */
    public cashDown: number = 0;

    /** Total amount of any principal paid as of the receivable day. */
    public principalPaid: number = 0;

    /** Computed percent principal paid ((principal from payments + cash down + trade net) / sale price) */
    public percentPrincipalPaid: number = 0;

    /** Total amount the coporation (lot/dealer) must collect before a break-even point is crossed. */
    public ridingCash: number = 0;

    /** Date and time this receivable record was initially created. */
    public createdAt: Date;

    /** The date of the most recent payment at the time the receivable record was created, if any.  */
    public prevPaymentDate: Date;

    /** Date and time this receivable record was last modified. */
    public updatedAt: Date;

    /** Unique internal identity of the collector associated with the receivable. */
    public collectorId: number = 0;

    /** Full name of the collector associated that is currently working this receivable. */
    public collector: string;

    /** Indicates the account is workable based on the last known work date, if any. */
    public workable: boolean = false;

    /** Date the recivable was last worked (payment made, note posted, call made, etc...) */
    public worked: Date;

    /** A pre-computed title for the receivable, typically the vehicle or the buyer. */
    public title: string;

    /** A pre-computed subtitle for the receivable, typically some combination of the vehicle or buyer. */
    public subtitle: string;

    /** Get the total amount due on the receivable day. */
    public total = (): number => {
        return ((this.deposit || 0) + (this.initial || 0) + (this.deferred || 0) + (this.loan || 0) + (this.lateFees || 0) + (this.cpi || 0))
    }
}
